var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.70852 25.667H17.624C18.3767 25.667 18.969 25.0426 18.819 24.305C18.405 22.2686 17.0526 18.667 12.6663 18.667C8.28003 18.667 6.92768 22.2686 6.5136 24.305C6.36362 25.0426 6.95586 25.667 7.70852 25.667Z",
    stroke: "#3F3F55",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 18.667C23.7717 18.667 24.9069 21.5309 25.3652 23.595C25.6127 24.7097 24.7111 25.667 23.5692 25.667H22.3333",
    stroke: "#3F3F55",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 13.6663C14.6917 13.6663 16.3333 12.0247 16.3333 9.99967C16.3333 7.97463 14.6917 6.33301 12.6667 6.33301C10.6416 6.33301 9 7.97463 9 9.99967C9 12.0247 10.6416 13.6663 12.6667 13.6663Z",
    stroke: "#3F3F55",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.667 13.6663C21.6921 13.6663 23.0003 12.0247 23.0003 9.99967C23.0003 7.97463 21.6921 6.33301 19.667 6.33301",
    stroke: "#3F3F55",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersIcon);
export default __webpack_public_path__ + "static/media/users-icon.aceefcb94fd8b0e970053eb225e22c65.svg";
export { ForwardRef as ReactComponent };